import React from "react"
import { graphql, useStaticQuery } from 'gatsby'
import MagaginSlider from "./magazine-slider"

export const MagazineSlide = () => {
  const data = useStaticQuery (
    graphql`
    query MagazineSlideQuery {
      magazineForSlide: allMicrocmsNotes(
        limit: 5
        sort: {fields: [publishedAt], order: DESC}
      ) {
        edges {
          node {
            notesId
            title
            thumbnail {
              url
            }
            middle_category {
              id
              name
              display_color
            }
          }
        }
      }
    }`
  )

  return (
    <>
    <div className="note_slide_wrap">
      <div className="note_slide_box clearfix">
        <MagaginSlider data={data} />
      </div>
    </div>
    </>
  )
}

export default MagazineSlide
